// Packages
import React, { useState } from 'react'
import { Script } from "gatsby"

// Imports

import VwoScript from './Scripts/VwoScript'

const Seo = ( data ) => {

    const title = !data?.title ? 'Frida: Adult ADHD Clinic' : data.url === '/' ? data.title : data.title + ' – Frida';
    const description = data?.description || 'Don’t let ADHD hold you back. Get an expert ADHD diagnosis today. It’s time to meet your best self.';

    const [oneTrustLoaded, setOneTrustLoaded] = useState(false)
    const [oneTrustTriggerLoaded, setOneTrustTriggerLoaded] = useState(false)
    const [segmentLoaded, setSegmentIsLoaded] = useState(false)

    return (
        <>

        {/* OneTrust Cookies Consent Notice */}
        <Script
            id="onetrust-cookie-consent"
            type="text/javascript"
            src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
            charSet="UTF-8"
            data-domain-script="01a0b07a-f185-74c0-bc81-9d4c03355a8f"
            onLoad={() => setOneTrustLoaded(true)}
        />

        {/* OneTrust Cookies Consent Notice Trigger */}
        {oneTrustLoaded &&
            <Script
                id="onetrust-cookie-consent-trigger"
                onLoad={() => setOneTrustTriggerLoaded(true)}
            >
            {`
                function OptanonWrapper() { };
            `}
            </Script>
        }

        {/* Google tag manager */}
        <Script id="gtag-config" strategy="idle">
        {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-PQT275H');
        `}
        </Script>

        {/* Segment's OneTrust Consent */}
        {oneTrustLoaded &&
            <Script
                id="segment-consent"
                type="text/javascript"
                src="https://cdn.jsdelivr.net/npm/@segment/analytics-consent-wrapper-onetrust@latest/dist/umd/analytics-onetrust.umd.js"
                strategy="idle"
                onLoad={() => setSegmentIsLoaded(true)}
            />
        }

        {/* Segment + Onetrust Wrapper */}
        {segmentLoaded &&
            <Script id="segment" strategy="idle">
            {`
                !function(){var i="analytics",analytics=window[i]=window[i]||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","screen","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware","register"];analytics.factory=function(e){return function(){if(window[i].initialized)return window[i][e].apply(window[i],arguments);var n=Array.prototype.slice.call(arguments);if(["track","screen","alias","group","page","identify"].indexOf(e)>-1){var c=document.querySelector("link[rel='canonical']");n.push({__t:"bpc",c:c&&c.getAttribute("href")||void 0,p:location.pathname,u:location.href,s:location.search,t:document.title,r:document.referrer})}n.unshift(e);analytics.push(n);return analytics}};for(var n=0;n<analytics.methods.length;n++){var key=analytics.methods[n];analytics[key]=analytics.factory(key)}analytics.load=function(key,n){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.setAttribute("data-global-segment-analytics-key",i);t.src="https://evs.track.purposemed.com/s8xhLr9BSi6S63p7yHxnkD/d5Sd615jmxgn6MMSC3sg4d.min.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r);analytics._loadOptions=n};analytics._writeKey="HSseZHd3mHE3qrdfsclwzAUCrwufRX2e";analytics._cdn = "https://evs.track.purposemed.com";analytics.SNIPPET_VERSION="5.2.0";
                withOneTrust(analytics).load("HSseZHd3mHE3qrdfsclwzAUCrwufRX2e");
                analytics.page();
                }}();
            `}
            </Script>
        }

        {/*
            VWO
            <VwoScript oneTrustTriggerLoaded={oneTrustTriggerLoaded} />
        */}

        {/* Hotjar Tracking Code  */}
        <Script id="hotjar" strategy="idle">
        {`
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:2791525,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
        </Script>

        {/* Meta Pixel  */}
        <Script id="meta-pixel" strategy="idle">
        {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '606451377323085');
            fbq('track', 'PageView');
        `}
        </Script>

        {/* Unbounce Popup  */}
        <Script id="ubounce-popup" strategy="idle" src="https://1ee4344b20504826b6ec48aa31d1082c.js.ubembed.com/" />

        <meta property="og:locale" content="en-CA" />
        <meta property="og:site_name" content="Frida" />
        <meta property="twitter:card" content="summary_large_image" />

        <meta property="og:type" content={data.type || 'website'} />

        <meta property="og:image" content={data.thumbnail || 'https://www.talkwithfrida.com/frida-thumbnail.png'} />
        <meta property="twitter:image" content={data.thumbnail || 'https://www.talkwithfrida.com/frida-thumbnail.png'} />

        <meta name="description" content={description} />
        <meta property="og:description" content={description} />
        <meta property="twitter:description" content={description} />

        <link rel="preload" href="/fonts/dm-serif-display-v10-latin-regular.woff2" as="font" type="font/woff2" crossOrigin />

        <title>{title}</title>
        <meta name="title" content={title} />
        <meta property="og:title" content={title} />
        <meta property="twitter:title" content={title} />

        {data.url && <meta property="og:url" content={`https://www.talkwithfrida.com${data.url}`} /> }
        {data.url && <meta property="twitter:url" content={`https://www.talkwithfrida.com${data.url}`} /> }
        {data.url && <link rel="canonical" href={`https://www.talkwithfrida.com${data.url}`} /> }

        </>
    )
}


export default Seo
